import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-banner-card',
  styleUrls: [],
  shadow: false,
})
export class DdaBannerCard {
  @Prop() banner_card_type?: string;
  @Prop() banner_card_id: string;
  @Prop() banner_card_url: string;
  @Prop() image_src: string;
  @Prop() image_alt: string;
  @Prop() banner_card_title: string;
  @Prop() banner_card_description: string;
  @Prop({ reflect: true }) custom_class: string = '';
  @Prop({ reflect: true }) banner_card_value: string = '';
  @Prop({ reflect: true }) banner_card_name: string = '';
  @Prop() component_mode?: string;

  render() {
    const cardClass = [
      'dda-banner-card',
      this.custom_class,
      this.component_mode,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Host>
        <button
          id={this.banner_card_id}
          name={this.banner_card_name}
          value={this.banner_card_value}
          class={cardClass}
          type="button"
          role="button"
          aria-labelledby={`${this.banner_card_id}-title ${this.banner_card_id}-desc`}
        >
          <img
            class="dda-banner-card-icon"
            src={this.image_src}
            alt={this.image_alt || this.banner_card_title || 'Banner card image'}
            aria-hidden={!this.image_alt && !this.banner_card_title}
          />
          <span class="dda-d-flex dda-flex-column">
            <span
              id={`${this.banner_card_id}-title`}
              class="dda-banner-card-title"
              role="heading"
              aria-level={2}
            >
              {this.banner_card_title}
            </span>
            <span
              id={`${this.banner_card_id}-desc`}
              class="dda-banner-card-description"
            >
              {this.banner_card_description}
            </span>
          </span>
        </button>

        {/* <a
          href={this.banner_card_url}
          target={}
          id={this.banner_card_id}
          class={cardClass}
          aria-labelledby={`${this.banner_card_id}-title`} 
        >
          <img
            class="dda-banner-card-icon"
            src={this.image_src}
            alt={this.image_alt || this.banner_card_title || 'Banner card image'}
            aria-hidden={!this.image_alt && !this.banner_card_title}
          />
          <span class="dda-d-flex dda-flex-column">
            <span
              id={`${this.banner_card_id}-title`}
              class="dda-banner-card-title"
              role="heading"
              aria-level={2}
            >
              {this.banner_card_title}
            </span>
            <span
              id={`${this.banner_card_id}-desc`}
              class="dda-banner-card-description"
            >
              {this.banner_card_description}
            </span>
          </span>
        </a> */}
      </Host>
    );
  }
}